import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const automationFields = `
id
detailsUniqueId
serviceIsAutomated
serviceAutomatedPart
serviceProvisions {
  id
  provisionUniqueId
  serviceProvisionMeans
  serviceSystemName
  serviceReachLink
}
serviceExistenceSources {
  id
  existenceUniqueId
  serviceExistenceSource
  serviceExistenceSourceLink
}
`


export const CREATE_SERVICE_BASIC_AUTOMATION_DETAILS = gql`
  mutation CreateServiceBasicAutomationDetailsMutation($input: ServiceBasicDetailsInputObjects!) {
    createServiceBasicAutomationDetailsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${automationFields}
      }

    }
  }
`

export const UPDATE_SERVICE_BASIC_AUTOMATION_DETAILS = gql`
  mutation UpdateServiceBasicAutomationDetailsMutation($input: ServiceBasicDetailsInputObjects!) {
    updateServiceBasicAutomationDetailsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${automationFields}
      }
    }
  }
`

export const GET_SERVICE_BASIC_AUTOMATION_DETAILS = gql`
query GetInstitutionServicesAutomationDetails($filtering: ServiceAutomationFilterInputObject) {
  getInstitutionServicesAutomationDetails(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${automationFields}
    }
  }
}
`

export const DELETE_SERVICE_BASIC_AUTOMATION_DETAILS = gql`
mutation DeleteServiceBasicAutomationDetailsMutation($detailsUniqueId: String) {
  deleteServiceBasicAutomationDetailsMutation(detailsUniqueId: $detailsUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
